export default __webpack_public_path__ + "static/media/info-logo.dd2c15c1.svg";